export const PAGE_ENUM = {
  INDEX: 'IndexPage',
  FORM: 'FormPage'
}